import {PageSubContainerSkeleton} from "@project/components/feedback";
import {Skeleton} from "@project/design-system-web";

export function UserRolesPending() {
  return (
    <PageSubContainerSkeleton>
      <Skeleton className="h-10 w-full rounded-md" />
      <Skeleton className="h-32 w-full rounded-md" />
    </PageSubContainerSkeleton>
  );
}
